import React from "react";
import { ErrorMessage, Formik } from "formik";
import { Col, Row, Image, Form } from "react-bootstrap";
import logo from "../../ui/templates/Logo.png";
import { ButtonDanger } from "../../ui/templates/buttons";
import { EN } from "../../ui/constants";
import { TeamPaymentForm } from "../../ui/templates/paymentForm";
import { Box } from "@material-ui/core";
import camera from "../../ui/templates/images.png";

class RegisterTeamForm extends React.Component {
  myRef = React.createRef();
  focusTextInput = (e) => {
    this.myRef.current.click(e);
  };
  validateEmpty = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    }
    return error;
  };
  validateName = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    }
    if (value.length < 6) {
      error = "minimum number of characters must be 6";
    }
    return error;
  };

  renderNumberOption = (busyNumbers, carNumber) => {
    const renderArray = [];
    for (let i = 1; i < 1000; i++) {
      if (!busyNumbers.includes(String(i))) {
        renderArray.push(<option key={i}>{i}</option>);
      } else if (Number(carNumber) === i) {
        renderArray.push(<option key={i}>{i}</option>);
      }
    }
    return renderArray;
  };

  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  render() {
    const {
      eventId,
      number,
      carValues,
      racingBracket,
      handleImageChange,
      image,
      handleCreateTeam,
      team,
      cardNonceResponseReceived,
      teamPaymentPrice,
      handleCancelClick,
    } = this.props;
    const team_info = team ? team.team_info : [];
    const values = team_info
      ? {
          logo: team_info.team_image || logo,
          name: team_info.team_name || "",
          description: team_info.team_description || "",
          car_number: team_info.car_number || "",
          make_car: team_info.car_make || "",
          model_car: team_info.car_model || "",
          car_value: team_info.car_value || "...",
          modification: team_info.car_modification_points || "",
          racing_bracket: team_info.car_racing_bracket || "...",
        }
      : {
          logo: logo,
          name: "",
          description: "",
          car_number: "",
          make_car: "",
          model_car: "",
          car_value: "...",
          modification: "",
          racing_bracket: "...",
        };
    return (
      <Box>
        <Formik
          initialValues={values}
          validate={(values) => {
            let errors = {
              name: this.validateName(values.name),
              description: this.validateEmpty(values.description),
              car_number: this.validateEmpty(values.car_number),
              model_car: this.validateEmpty(values.model_car),
              car_value: this.validateEmpty(values.car_value),
              modification: this.validateEmpty(values.modification),
              racing_bracket: this.validateEmpty(values.racing_bracket),
            };

            Object.keys(errors).forEach((key) => {
              if (errors[key] === undefined) {
                delete errors[key];
              }
            });
            return errors;
          }}
          onSubmit={(values) => {
            const carInfo = {
              number:
                values.car_number === team_info.car_number
                  ? null
                  : values.car_number,
              make: values.make_car,
              model: values.model_car,
              car_value_id:
                values.car_value === team_info.car_value
                  ? null
                  : values.car_value,
              racing_bracket_id:
                values.racing_bracket === team_info.car_racing_bracket
                  ? null
                  : values.racing_bracket,
              modification_points: values.modification,
            };
            const teamInfo = {
              name: values.name === team_info.team_name ? null : values.name,
              description: values.description,
              image: image,
              event_id: eventId,
            };

            handleCreateTeam(carInfo, teamInfo);
          }}
        >
          {({ values, handleChange, handleSubmit, handleBlur }) => (
            <form onSubmit={handleSubmit}>
              <Row className="rowProfileScreen">
                <Col>
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label className="InputformLabel">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          name="name"
                          maxLength={100}
                        />
                        <ErrorMessage
                          name="name"
                          className="error-msg"
                          component="Box"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="InputformLabel">
                          Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows="5"
                          type="text"
                          placeholder="Description"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                          name="description"
                          className="profile-textarea"
                        />
                        <ErrorMessage
                          name="description"
                          className="error-msg"
                          component="Box"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="auto">
                      <Form.Group>
                        <Form.Label className="InputformLabel">
                          Team Logo
                        </Form.Label>
                        <Box height={200} width={200} mt="10px">
                          <Box
                            display="flex"
                            flexDirection="column"
                            border="1px solid #DCDCDC"
                            width="200px"
                            height="200px"
                            bgcolor="#F7F7F7"
                            justifyContent="center"
                            borderRadius={5}
                            alignItems="center"
                          >
                            <Box
                              className="teamProfileImageScreen"
                              mb={2}
                              height={120}
                              width={120}
                              position="relative"
                            >
                              <Image
                                src={image || values.logo}
                                className="team-profile-image"
                              />
                              <Box className="team-profile-upload">
                                <img
                                  src={camera}
                                  alt=""
                                  onClick={this.focusTextInput}
                                  style={{ cursor: "pointer" }}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                ref={this.myRef}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Form.Group>
                    </Col>
                  </Row>

                  {team?.team_info?.event_title && (
                    <Form.Group>
                      <Form.Label className="InputformLabel">
                        Event Title
                      </Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={team?.team_info?.event_title}
                        name="eventTitle"
                        disabled
                      />
                    </Form.Group>
                  )}
                  <Box pt={1}>
                    <Box
                      borderTop="1px solid #DCDCDC "
                      className="fontStyle teamHeading"
                      pt={2}
                      mb={1}
                    >
                      Car Information
                    </Box>
                    <Box
                      display="flex"
                      alignItems="top"
                      width="100%"
                      justifyContent="space-between"
                      flexDirection={["column", "column", "row"]}
                    >
                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            Car No
                          </Form.Label>
                          <Form.Control
                            as="select"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.car_number}
                            name="car_number"
                          >
                            <option>Car Number</option>
                            {number
                              ? this.renderNumberOption(number, null)
                              : null}
                            {team
                              ? this.renderNumberOption(
                                  team.busy_cars_numbers,
                                  team_info.car_number
                                )
                              : null}
                          </Form.Control>
                          <ErrorMessage
                            name="car_number"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>

                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            Make of Car
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Make of Car"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.make_car}
                            name="make_car"
                            maxLength={30}
                          />
                          <ErrorMessage
                            name="make_car"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>

                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            Car Model
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Model of Car"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.model_car}
                            name="model_car"
                            maxLength={30}
                          />
                          <ErrorMessage
                            name="model_car"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>
                    </Box>

                    <Box
                      display="flex"
                      alignItems="top"
                      width="100%"
                      justifyContent="space-between"
                      flexDirection={["column", "column", "row"]}
                    >
                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            Car Value
                          </Form.Label>
                          {team && carValues && (
                            <Form.Control
                              value={values.car_value}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="car_value"
                              as="select"
                            >
                              <option defaultValue disabled>
                                {team_info.car_value}
                              </option>
                              {carValues.length
                                ? carValues.map((val, k) => {
                                    return (
                                      <option
                                        key={k}
                                        id={val.id}
                                        value={val.id}
                                      >
                                        {val.value}
                                      </option>
                                    );
                                  })
                                : null}
                            </Form.Control>
                          )}
                          {carValues && !team && (
                            <Form.Control
                              value={values.car_value}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="car_value"
                              as="select"
                            >
                              <option>...</option>
                              {carValues.length
                                ? carValues.map((val, k) => {
                                    return (
                                      <option
                                        key={k}
                                        id={val.id}
                                        value={val.id}
                                      >
                                        {val.value}
                                      </option>
                                    );
                                  })
                                : null}
                            </Form.Control>
                          )}

                          <ErrorMessage
                            name="car_value"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>

                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            modification
                          </Form.Label>
                          <Form.Control
                            value={values.modification}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="modification"
                            as="select"
                          >
                            <option>Modification Points Used</option>
                            {EN.modification_points_used.map((val, k) => {
                              return (
                                <option key={k} value={val}>
                                  {val}
                                </option>
                              );
                            })}
                          </Form.Control>
                          <ErrorMessage
                            name="modification"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>

                      <Box width={["100%", "50%", "33%"]}>
                        <Form.Group>
                          <Form.Label className="InputformLabel">
                            Racing Bracket
                          </Form.Label>
                          {racingBracket && !team ? (
                            <Form.Control
                              value={values.racing_bracket}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              as="select"
                              name="racing_bracket"
                            >
                              <option>Racing Bracket</option>
                              {racingBracket.map((val, k) => {
                                return (
                                  <option key={k} id={val.id} value={val.id}>
                                    {val.value}
                                  </option>
                                );
                              })}
                            </Form.Control>
                          ) : null}
                          {team && racingBracket ? (
                            <Form.Control
                              value={values.racing_bracket}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              as="select"
                              name="racing_bracket"
                            >
                              <option defaultValue disabled>
                                {team_info.car_racing_bracket}
                              </option>
                              {racingBracket.map((val, k) => {
                                return (
                                  <option key={k} id={val.id} value={val.id}>
                                    {val.value}
                                  </option>
                                );
                              })}
                            </Form.Control>
                          ) : null}
                          <ErrorMessage
                            name="racing_bracket"
                            className="error-msg"
                            component="Box"
                          />
                        </Form.Group>
                      </Box>
                    </Box>
                  </Box>
                  <Form.Group className="submit-button">
                    <ButtonDanger text={EN.save} type="submit" />
                  </Form.Group>
                </Col>
              </Row>
            </form>
          )}
        </Formik>

        {team?.team_info?.event_id && (
          <TeamPaymentForm
            show={teamPaymentPrice > 0 && true}
            team={team}
            eventId={team?.team_info?.event_id}
            cardNonceResponseReceived={cardNonceResponseReceived}
            handleCancelClick={handleCancelClick}
          />
        )}
      </Box>
    );
  }
}

export default RegisterTeamForm;
